// 页面加载完成后执行
document.addEventListener('DOMContentLoaded', function() {
  // 获取所有岗位卡片和筛选项
  const jobCards = document.querySelectorAll('.job-card');
  const filterItems = document.querySelectorAll('.filter-item');
  const copyBtns = document.querySelectorAll('.copy-btn');

  // 复制链接功能
  copyBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      // 阻止事件冒泡（不触发父级a标签跳转）+ 阻止默认行为
      e.preventDefault();
      e.stopPropagation();

      const url = this.dataset.url;
      const self = this;
      navigator.clipboard.writeText(url).then(() => {
        // 文字变化+绿色背景
        self.textContent = '✔ COPIED';
        self.classList.add('success');
        // 1.5秒后恢复原样
        setTimeout(() => {
          self.textContent = 'COPY';
          self.classList.remove('success');
        }, 1500);
      });
    });
  });

  // 筛选函数
  function filterJobs() {
    // 获取当前选中的筛选条件
    const selectedType = document.querySelector('input[name="type"]:checked').parentElement.dataset.type;
    const selectedDept = document.querySelector('input[name="dept"]:checked').parentElement.dataset.dept;
    const selectedLocation = document.querySelector('input[name="location"]:checked').parentElement.dataset.location;

    // 遍历岗位卡片，匹配筛选条件
    jobCards.forEach(card => {
      const cardType = card.dataset.type;
      const cardDept = card.dataset.dept;
      const cardLocation = card.dataset.location;

      const matchType = selectedType === 'all' || cardType === selectedType;
      const matchDept = selectedDept === 'all' || cardDept === selectedDept;
      const matchLocation = selectedLocation === 'all' || cardLocation === selectedLocation;

      card.style.display = (matchType && matchDept && matchLocation) ? 'block' : 'none';
    });
  }

  // 页面加载时自动执行筛选（修复默认不显示问题）
  filterJobs();

  // 点击筛选时执行
  filterItems.forEach(item => {
    item.addEventListener('click', function() {
      const radio = this.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      filterJobs();
    });
  });
});